<template>
    <div class="" id="form-sponsor">
        <div class="form card-lock">
            <h2>Стать спонсором конференции</h2>
            <div class="notes">Оставьте контакты и мы с Вами свяжемся</div>
            <!-- <div class="notes">Если Вы хотите прийти на конференцию, оставьте пожалуйста заявку</div> -->
            <Transition mode="out-in">
                <form v-if="!complite" action="/sendform/zapis" method="get">
                    <div class="input">
                        <!-- <label>Имя:</label> -->
                        <!-- <input v-model="name" name="name" type="text" placeholder="Введите ваше имя" :required="true" :class="{ 'valid': nameValid, 'invalid': !nameValid && name }"> -->
                        <input 
                            :value="name" @input="e => name = e.target.value"
                            name="name" type="text" placeholder="Представтесь, пожалуйста *" :required="true" :class="{ 'valid': nameValid, 'invalid': !nameValid && name }">
                    </div>
                    <div class="input">
                        <!-- <label>e-Mail:</label> -->
                        <!-- <input v-model="email" name="email" type="email" placeholder="Введите ваш e-mail" :required="true" :class="{ 'valid': emailValid, 'invalid': !emailValid && email }"> -->
                        <input 
                            :value="email" @input="e => email = e.target.value"
                            name="email" type="email" placeholder="Электронная почта *" :required="true" :class="{ 'valid': emailValid, 'invalid': !emailValid && email }">
                    </div>
                    <div class="input">
                        <!-- <label>Телефон:</label> -->
                        <input v-model="tel" name="tel" type="tel" placeholder="Номер телефона" :required="true" :class="{ 'valid': telValid, 'invalid': !telValid && tel }">
                    </div>
                    <div class="input">
                        <!-- <label>Телефон:</label> -->
                        <input
                            :value="comp" @input="e => comp = e.target.value"
                            name="comp" placeholder="Какую компанию вы представляете *" :required="true" :class="{ 'valid': compValid, 'invalid': !compValid && comp }">
                    </div>
                    <div class="input">
                        <textarea 
                            :value="text" @input="e => text = e.target.value"
                            :required="false"
                            name="text"
                            placeholder=""
                            rows="5"
                        ></textarea>
                    </div>
                    <Transition mode="out-in">
                        <div v-if="!waiting" class="submit">
                            <small>Нажимая на кнопку "отправить", Вы даёте <a href="#" class="personal" @click.prevent="handleClickPersonal">согласие на обработку персональных данных</a></small>
                            <button @click.prevent="handleClickSendZapis" :disabled="disabled">Отправить</button>
                        </div>
                        <div v-else class="waiting">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </Transition>
                </form>
                <div v-else class="complite">
                    <template v-if="statusOk">
                        <p>Ваша сообщение отправлено.</p>
                        <!-- <p>На указанный вами адрес электронной почты придёт приглашение.</p> -->
                    </template>
                    <template v-else>
                        <p>Ой, что-то пошло не так. Попробуйте чуть тозже.</p>
                    </template>
                </div>
            </Transition>
        </div>
    </div>
    <Transition>
        <PersonalBlock v-if="isOpenPersonal" @close-personal="handleClickPersonal"/>
    </Transition>
</template>
<script>
import { validationComp, validationEmail, validationName, validationTel } from '@/lib/validation';
import PersonalBlock from '@/components/PersonalBlock.vue';
export default {
    name: 'SponsorForm',
    components: { PersonalBlock },
    props: {
        sendResult: Object,
    },
    data() {
        return {
            waiting: false,
            complite: false,
            statusOk: true,
            name: '',
            nameValid: null,
            email: '',
            emailValid: null,
            tel: '',
            telValid: null,
            comp: '',
            compValid: null,
            text: '',
            timer: null,
            isOpenPersonal: false,
            // disabled: true, -> computed
        }
    },
    emits: [ 'returnData' ],
    mounted() {
    },
    methods: {
        handleClickSendZapis: function() {
            console.log('handleClickSendZapis')
            this.$emit('returnData', { form: 'sponsor', name: this.name, email: this.email, tel: this.tel, comp: this.comp, text: this.text } )
            this.waiting = true
        },
        flushState: function() {
            this.waiting = false
            this.complite = false
            this.statusOk = true
            clearTimeout(this.timer)
        },
        handleClickPersonal: function() {
            this.isOpenPersonal = !this.isOpenPersonal
        },

        validationEmail,
        validationTel,
        validationName,
        validationComp,
    },
    watch: {
        name: 'validationName',
        tel: 'validationTel',
        email: 'validationEmail',
        comp: 'validationComp',

        sendResult: function(result) {
            
            console.log('result', result )
            if ( result.status === 200 ) {
                if ( result.data.code === 200 ) {
                    this.waiting = false 
                    this.complite = true
                    this.statusOk = true
                } else {
                    this.waiting = false 
                    this.complite = true
                    this.statusOk = false
                }
            } else {
                this.waiting = false 
                this.complite = true
                this.statusOk = false
            }
            this.timer = setTimeout(() => {
                this.flushState()
            }, 15000 );
        },
    },
    computed: { 
        disabled: function() {
            if ( this.nameValid && this.emailValid && this.compValid ) {
                return false
            }
            return true
        },
    }
}
</script>
<style lang="scss">
$primary: #1E9BD8;
$secondary: #45289C;
#form-sponsor{
    .form{
        // background-color: #243255;
        background-color: $secondary;
        background-image: none;
        color: #fff;
        font-size: 1.25em;
        padding: 15px;
        border-radius: 15px;
        .notes{
            font-size: .85em;
            margin-bottom: 1.25em;
            text-align: left;
            color: $primary;
            text-transform: uppercase;
        }
        .input{
            margin-bottom: 1em;
            &:last-child{
                margin-bottom: 0;
            }
            flex-basis: 100%;
            display: flex;
            label{
                flex-grow: 1;
                flex-basis: 12%;
                text-align: end;
                padding-right: .25em;
                @media ( max-width: 992px) {
                    display: none;
                }
            }
            input{
                border: solid 1px $primary;
                background-color: $secondary;
                color: #fff;
                border-radius: 16px;
                height: 24px;
                width: 100%;
                font-size: .8em;
                transition: .4s;
                padding: .25em .85em;
                &.invalid:not(:focus){
                    background-color: #dc3030;
                }
                &.valid:focus{
                    background-color: #72c15d;
                }
                &::placeholder{
                    color: #ffffff;
                    font-size: .8em;
                }
                &:focus{
                    transition: .4s;
                    outline: #fff;
                    // background-color: lighten($primary, 15%);
                    background-color: darken($primary, 5%);
                }
            }
            textarea{
                width: 100%;
                border: solid 1px $primary;
                background-color: $secondary;
                color: #fff;
                border-radius: 16px;
                font-size: .8em;
                transition: .4s;
                padding: .85em .85em;
                &.invalid:not(:focus){
                    background-color: #dc3030;
                }
                &.valid:focus{
                    background-color: #72c15d;
                }
                &::placeholder{
                    color: #ffffff;
                    font-size: .8em;
                }
                &:focus{
                    transition: .4s;
                    outline: #fff;
                    // background-color: lighten($primary, 15%);
                    background-color: darken($primary, 5%);
                }
            }
        }
        .submit{
            display: flex;
            flex-direction: column;
            // justify-content: flex-end;
            small{
                width: 100%;
                // font-weight: 100;
                font-size: .65em;
                text-align: center;
                color: darken(#fff, 15%);
                .personal{
                    // text-transform: none;
                    // background-color: transparent;
                    // padding: 0;
                    color: darken(#fff, 10%);
                    // border-bottom: solid 1px #fff;
                    // border-radius: 0;
                }
                padding-bottom: 1em;
            }
            button{
                font-size: 1em;
                padding: .5em .85em;
                text-transform: uppercase;
                color: #fff;
                border: #fff;
                border-radius: 16px;
                background-color: $primary;
                transition: .4s;
                cursor: pointer;
                &:disabled{
                    // background-color: #374d85;
                    cursor: auto;
                    color: darken($secondary, 10%);
                    transition: .4s;
                }
                @media ( max-width: 992px) {
                    width: 100%
                }
                &:hover{
                    transition: .4s;
                    background-color: lighten(#374d85, 15%);
                }
            }
        }
        .waiting{
            display: flex;
            justify-content: center;
            div{
                height: 5px;
                width: 5px;
                background-color: #fff;
                margin: .25em;
                border-radius: 50%;
                position: relative;
    
                // animation-delay: 10s;
                animation-name: loading;
                animation-iteration-count: infinite;
                animation-duration: .85s;
                animation-direction: alternate;
                animation-timing-function: ease-in;
                &:nth-child(2) {
                    animation-delay: .25s;
                }
                &:nth-child(3) {
                    animation-delay: .5s;
                }
            }
        }
        .complite{
            text-align: center;
        }
        @keyframes loading {
            from{
                top: -4px;
            }
            to{
                top: 4px;
            }
        }
    }
}
</style>